import { atom } from "recoil";

export const walletGroupsEditModalStore = atom({
	key: "walletGroupsEditModalStore",
	default: {
		show: false,
		section: "verification",
		project: null,
		loaded: true,
		id: 0,
		method: "",
		enabled: false,
		types: [],
		currencyMode: "all",
		currencies: [],
		partnerExceptions: [],
		partnerExceptionsText: "",
		availableCurrencies: [],
		sourceValid: true,
		sourceError: "",
		rawVerification: "0",
		changed: false,
	},
});
